import api, { ResponseCallback } from '../services/api.service'
import { ModuleData } from './module.api'
import { SitePermissionData } from './sitePermission.api'
import { UserPermissionData } from './userPermission.api'

export interface PermissionData {
  id: number
  moduleId: number
  administrative: boolean
  advanced: boolean
  sitePermission?: SitePermissionData
  userPermission?: UserPermissionData
  module?: ModuleData
}

const routes = {
  list: '/permissions'
}

export default {
  list (callback: ResponseCallback<PermissionData[]>) {
    api.get(routes.list, {}, callback)
  }
}
